module.exports = __webpack_public_path__ + "img/type-03.3acc5d5b.jpg";